<template>
  <div class="page pyby">
    <div :class="contentClass">
      <component
        :is="curretTabName"
        :tabData="this.tabs[this.currentTab]"
        @showVidoe="showVideo"
        @showVideoBehind="showVideoBehind"
      ></component>
    </div>
    
    <BottomNav
      :page="page"
      :items="tabs"
      :active="currentTab"
      class="pyby-tabnav"
      :class="lngClass"
      btnclass="pyby-nav"
      @changeNav="changeTab"
      wrap
    ></BottomNav>

    <VideoPlay
      v-if="videoPlayer"
      :headers="videoHeaders"
      :info="videoInfo"
      @closePlayer="videoPlayer = false"
    ></VideoPlay>

    <VideoPlay
      v-if="videoPlayerBehind"
      :headers="videoHeaders"
      :info="videoInfo"
      behind
      @closePlayer="videoPlayerBehind = false"
    ></VideoPlay>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

import BottomNav from "@/components/BottomNav.vue";
import Method from "./Method.vue";
import Gramophone from "./Gramophone.vue";
import Theater from "./Theater.vue";
import Prelude from "./Prelude.vue";
import VideoPlay from "@/components/VideoPlay.vue";

export default {
  components: {
    BottomNav,
    "m-method": Method,
    "m-gramophone": Gramophone,
    "m-theater": Theater,
    "m-prelude": Prelude,
    VideoPlay
  },
  data() {
    return {
      page: "pyby",
      currentTab: 0,
      videoHeaders: [
        { name: "表演人", tag: "perfomer" },
        { name: "演员", tag: "actor" },
        { name: "地域", tag: "region" },
        { name: "录制地", tag: "record_place" },
        { name: "唱腔", tag: "aria" },
        { name: "关键词", tag: "keywords" },
        { name: "简介", tag: "description" }
      ],
      videoInfo: {},
      videoPlayer: false,
      videoPlayerBehind: false
    };
  },
  computed: {
    ...mapState({
      tabs: state => state.tabs.pyby,
      pyby: "pyby"
    }),
    ...mapGetters(["lngClass"]),
    curretTabName() {
      const tabName = this.tabs[this.currentTab].name;
      return tabName ? `m-${tabName}` : "";
    },
    contentClass() {
      return `${this.page}-tabs`;
    }
  },
  mounted() {},
  methods: {
    changeTab(activeNum) {
      this.currentTab = activeNum;
    },
    showVideo(data) {
      this.videoInfo = data;
      this.videoPlayer = true;
    },
    showVideoBehind(data) {
      this.videoInfo = data;
      this.videoPlayerBehind = true;
    },
  }
};
</script>

<style lang="scss">
@import "../../assets/base";
.pyby-tabnav {
  bottom: 1rem;

  .pyby-nav {
    margin: 0 0.4rem;
    @include tab2;

    .icon {
      width: 3.5rem;
      height: 3.5rem;
      background-size: 3rem 3rem;
    }
  }

  &.lng {
    bottom: 0.5rem;
    .pyby-nav {
      width: 20vw;
      span {
        white-space: normal;
      }
    }
  }
}
</style>
